import React from 'react';

import {BreadCrumb, CustomView, ResponsiveView, Pagination, TableHeader, TableLoading} from '../../../../components';
import Context from "../../../../context";
import {useTranslation} from "react-i18next";

import NeighborhoodComponents from "./Components";
import values from "../../../../values";

type Props = {
  rqData: any
};

const NeighborhoodScreen: React.FC<Props> = (props: Props): React.ReactElement => {

  // # =================================================================================================================
  // # --------------------------------------------- Start Validate Values ---------------------------------------------

  const { requestNeighborhood, setRequestNeighborhood } = React.useContext(Context.Location.Neighborhood);
  const { t } = useTranslation();

  // # ---------------------------------------------- End Validate Values ----------------------------------------------
  // # =================================================================================================================

  // ? =================================================================================================================
  // ? ----------------------------------------------- Start Return View -----------------------------------------------

  return (
    <ResponsiveView.Container id='location-area-screen-wrapper'>
      <CustomView.Row className="table-options-wrapper">
        <CustomView.Column extraLarge={3} large={5} medium={5} className="bread-crumb-wrapper">
          <BreadCrumb />
        </CustomView.Column>
        <CustomView.Column extraLarge={4} large={5} medium={7} className="search-and-filter-wrapper">
          <NeighborhoodComponents.Search />
          <NeighborhoodComponents.Filter />
          <NeighborhoodComponents.Create />
        </CustomView.Column>
      </CustomView.Row>
      <ResponsiveView.Container>
        <div className="table-content-wrapper">
          <table>
            <TableHeader headers={values.tableHeaders.LOCATION_NEIGHBORHOOD_TABLE.map((item) => t(item))}/>
            {props.rqData?.status === "loading" ? (<TableLoading />) : (<NeighborhoodComponents.Body data={props.rqData} />)}
          </table>
        </div>
      </ResponsiveView.Container>
      {props.rqData?.status === 'success' &&
        props.rqData?.data?.result?.totalDocs > 10 && (
          <div className="pagination">
            <Pagination
              page={Number(requestNeighborhood?.page)}
              totalPages={props.rqData?.data?.result?.totalPages}
              onPaginate={(page: number) => setRequestNeighborhood!({...requestNeighborhood, page: page,})}
            />
          </div>
        )
      }
      <NeighborhoodComponents.Update />
      <NeighborhoodComponents.Delete />
    </ResponsiveView.Container>
  );

  // ? ------------------------------------------------ End Return View ------------------------------------------------
  // ? =================================================================================================================

}

export default NeighborhoodScreen;
